export default __webpack_public_path__ + "static/media/Thi-35.5b931d3b.svg";